import dynamic from "next/dynamic"
import React from "react"
import { useSiteContext, useTranslations } from "@dustin-web/microsite-components/src/hooks"
import { getCultureCode, getDefaultLanguage } from "@dustin-web/microsite-config"
import { CarouselTest } from "@dustin-web/microsite-components/src/carousel-test/carousel"
import type { SliderType } from "@dustin-web/microsite-components/src/carousel-test/settings"
import type { DigitalDataOrigin } from "../../../utils/digital-data-types"
import type { LandingPageGroupList } from "../../data/types"
import { ListItemRenderer } from "../../../product-list"
import { getCtaLink } from "../../utils/attributes"
import { getBgColorThemeClass } from "../../utils/color-theme"

const ArrowRightIcon = dynamic(() => import("@dustin-web/microsite-components/src/icon/generated/arrow-right"))

type Props = {
  groupList: LandingPageGroupList
  digitalDataOrigin: DigitalDataOrigin
  sliderType?: SliderType
  fullWidth?: boolean
}

const LandingPageVariantSlider = ({ groupList, digitalDataOrigin, sliderType, fullWidth }: Props) => {
  const { translate } = useTranslations()
  const { site } = useSiteContext()
  const lang = getDefaultLanguage(site)
  const langCultureCode = getCultureCode(lang)

  const { attributes, productReferences } = groupList ?? {}
  const { colorTheme = 'gray', ctaText } = attributes ?? {}
  const ctaLink = getCtaLink(attributes, langCultureCode)

  return productReferences && productReferences?.length && (
    <>
      <CarouselTest
        dots
        partialVisible
        dotMode="full-width"
        type={
          sliderType ? sliderType : fullWidth ? 'startpage' : 'startpageFullWidthFalse'
        }
        fullWidth={fullWidth}
        colorTheme={colorTheme}
        list={productReferences.map(
          ({ product, ticket }, key) =>
            product && (
              <ListItemRenderer
                imagePriority
                key={ticket + key}
                product={product}
                ticket={ticket}
                listType={'stripped'}
                gallerySizeClasses={'slider-card u-px-8'}
                digitalDataOrigin={digitalDataOrigin}
                digitalIndex={key}
              />
            )
        )}
      />
      {ctaLink && ctaText && (
        <a
          className={`
            d-flex
            align-items-center
            u-button-opacity
            u-px-16
            u-radius-2
            u-color-white
            u-decoration-none
            u-fs-14
            u-h-40
           ${getBgColorThemeClass(colorTheme, 'dark')}
          `}
          href={ctaLink}
          style={{ marginLeft: 'auto', width: 'fit-content' }}>
          <span className="u-mr-32">{translate(ctaText)}</span>
          <ArrowRightIcon className={'i-16'} />
        </a>
      )}
    </>
  )
}

export default LandingPageVariantSlider
